import {create} from 'zustand';

/** How the queue is ordered everywhere it shows: the rail, Home's rolodex, the table. */
export type QueueSort = 'newest' | 'oldest';

type QueueSortState = {
  sort: QueueSort;
  setSort: (sort: QueueSort) => void;
};

/**
 * One order for the whole shell. The rail and the canvas each carry the toggle, and
 * flipping either flips both — a queue sorted two ways at once reads as two queues.
 * Oldest first by default: the quote that has waited longest is the one to pick up.
 */
export const useQueueSort = create<QueueSortState>((set) => ({
  sort: 'oldest',
  setSort(sort) {
    set({sort});
  },
}));
